/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {DictionaryItem} from '../models/DictionaryItem';
import type {Error} from '../models/Error';

export interface GetLicenseTypes$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getLicenseTypesRequest = createAction<PayloadData<void>>('GET_LICENSE_TYPES__GET_LICENSE_TYPES__REQUEST');
export const getLicenseTypesSuccess = createAction<PayloadData<Array<DictionaryItem>>>('GET_LICENSE_TYPES__GET_LICENSE_TYPES__SUCCESS');
export const getLicenseTypesFailure = createAction<PayloadData<Error, void, true>>('GET_LICENSE_TYPES__GET_LICENSE_TYPES__FAILURE');

export const getLicenseTypesActions = [
    getLicenseTypesRequest,
    getLicenseTypesSuccess,
    getLicenseTypesFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getLicenseTypes = (config?: GetLicenseTypes$Config) => {
    return {
        CALL_API: {
            types: getLicenseTypesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/dictionaries/license-type`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

